import loadjs from "loadjs";
import { ua } from "../ua";
import corsImport from "../corsImport";
import { webOpen } from "./openLink";
import { convertWWOpenData } from '../react-plugin/ww-open-data';
import { showImage, showVideo, showAudio } from './filePreview';
import Queue from "./Queue";
import { getLabel } from "../locale";
import { getSecondPathUrl } from "../open";

const publicUrl: string = window.publicUrlstatic || window.publicUrl || '';
const publicUrlapi: string = window.publicUrlapi || window.publicUrl || '';
const isSecondPath: Boolean =  !!(publicUrl || publicUrlapi);

export function needConvertWechatData() {
  return /^ebridge/.test(window.TEAMS?.currentUser?.loginChannel) && (window.TEAMS?.authWecahtBook === false || window.TEAMS?.wxTotalNeedConvertCount > 0);
}

export interface Task {
  func: Function;
  resolve: Function;
  reject: Function;
};

export function getExtendName(name: string) {
  const index = name.lastIndexOf('.');
  const suffix = index === -1 ? '' : name.substr(index + 1);
  return suffix;
}

class SDK {
  /**
   * sdk的名称
   */
  public sdkName: string;
  /**
   * sdk的实例
   */
  public customSDK: any;
  /**
   * register注册的方法
   */
  public commandList: any;
  /**
   * 通过ecode自定义添加的方法，主要用于checkApi时使用
   */
  public commandCheckList: any;

  public readyQueue = new Queue<Task>();

  /**
   * sdk 是否 ready完成
  */
  public sdkIsReady: boolean = false;

  webOpen = webOpen;

  constructor() {
    this.sdkName = '';
    this.commandList = {};
    this.commandCheckList = {};
  }

  /**
   * 加载SDK，并初始化sdk
   * @param sdkName sdk的名称
   * @param filePath 加载sdk的路径地址
   * @returns Promise<SDK>
   */
  initSDK = (sdkName: string, filePath?: string | Array<string>) => {
    return new Promise((resolve, reject) => {
      if (!sdkName) {
        reject('sdkName not set')
      }
      this.sdkName = sdkName;
      if (sdkName.indexOf('@weapp/') === 0) {
        corsImport(sdkName).then((weapp) => {
          if (weapp) {
            this.customSDK = weapp;
            if (this.customSDK.ready) {
              this.customSDK.ready(() => {
                this.sdkIsReady = true;
                this.invokeReady();
                resolve(this)
              });
            } else {
              this.sdkIsReady = true;
              this.invokeReady();
              resolve(this)
            }
          } else {
            this.invokeReady(true);
            reject(sdkName + ' is empty');
          }
        }).catch((err) => {
          this.invokeReady(true);
          reject(err);
        })
      } else {
        if (!filePath) {
          this.invokeReady(true);
          reject('filePath not set')
        } else {
          const loadOptions = {
            success: () => {
              this.sdkIsReady = true;
              this.invokeReady();
              resolve(this);
              return;
            },
            error: (err: any) => {
              this.invokeReady(true);
              alert(getLabel('184759','加载文件失败：') + sdkName)
              reject('加载文件失败：' + sdkName)
            }
          };
          if (loadjs.isDefined(sdkName)) {
            loadjs.ready(sdkName, loadOptions);
            resolve(this)
            return;
          }
          loadjs(filePath, sdkName);
          loadjs.ready(sdkName, loadOptions);
        }
      }
    })
  }

  /**
   * 重新替换加载到的sdk的实例
   * @param instance 新sdk的实例
   */
  setInstance = (instance: any) => {
    this.customSDK = instance
  }

  /**
   * 注册方法列表
   * @param command 
   * @param customFunc 
   */
  register = (command: string, customFunc: Function) => {
    this.commandList[command] = customFunc
  }

  /**
   * sdk加载成功后的回调
   * @param func 
   * @returns 
   */
  ready = (func: Function, command?: string) => {
    return new Promise((resolve, reject) => {
      if (!func || typeof func !== 'function') reject('ready 需要接受function 作为参数');
      if (this.customSDK && this.customSDK.isApiReady) { // 针对微信里初始化加载引用云桥组件是不走单点登录的情况处理
        if (this.sdkIsReady || this.customSDK.isApiReady(command)) {
          func(this);
          resolve(this);
          return;
        }
      }
      if (this.customSDK && this.sdkIsReady) {
        func(this);
        resolve(this);
        return;
      }
      this.readyQueue.push({ func, resolve, reject });
    });
  }

  /**
   * 执行ready
   * @param failed 
   */
  private invokeReady = (failed?: boolean) => {
    while(!this.readyQueue.isEmpty()) {
      const task = this.readyQueue.pop();
      if (failed) {
        task?.reject();
      } else {
        task?.func();
        task?.resolve(this);
      }
    }
  }

  /**
   * 检查comman方法是否已经注册
   * @param command 需要检查的command
   * @returns Promise<string>
   */
  checkApi = (command: string) => {
    return new Promise((rs, rj) => {
      if (typeof (this.commandCheckList[command]) === 'function') {
        this.commandCheckList[command]().then((res: any) => {
          rs(res);
        }).catch(() => {
          rj();
        })
      } else {
        if (typeof (this.commandList[command]) === 'function') {
          rs('success');
        } else {
          if (this.sdkName === '@weapp/em-jssdk' && this.customSDK && this.customSDK.ready) {
            this.customSDK.ready(() => {
              if (this.customSDK.checkJsApi && this.customSDK.checkJsApi(command)) rs('success');
              else rj();
            })
          } else if (this.customSDK && this.customSDK.checkJsApi && this.customSDK.checkJsApi(command)) {
            rs('success');
          } else {
            rj();
          }
        }
      }
    })
  }

  /**
   * 执行sdk方法
   * @param command 方法名称
   * @param params 执行方法传入的参数
   * @returns Promise<any>
   */
  invoke = (command: string, params: any) => {
    return new Promise((resolve, reject) => {
      params.success = resolve
      params.fail = reject
      if (this.commandList[command] && typeof (this.commandList[command]) === 'function') {
        this.commandList[command](params)
      } else {
        if (this.customSDK && this.customSDK.invoke) {
          var domain = window.location.protocol + '//' + window.location.host
          // shareToWechat
          if (params.messageType && params.messageType === 3) {
            if (params.webpageUrl && !/^http/.test(params.webpageUrl)) {
              params.webpageUrl = domain + params.webpageUrl
            }
          }

          // shareToExternal
          if (params.shareType && params.shareType === 3) {
            if (params.url && !/^http/.test(params.url)) {
              params.url = domain + params.url
            }
          }

          // shareAppMessage
          if (params.link && !/^http/.test(params.link)) {
            params.link = domain + params.link
          }
          // sendChatMessage
          if (params.msgtype && params.msgtype === 'news') {
            if (params.new?.link && !/^http/.test(params.new?.link)) {
              params.new.link = domain + params.news.link
            }
          }
          this.customSDK.invoke(command, params)
        } else {
          reject('SDK异常 invoke未注册');
        }
      }
    })
  }

  /**
   * 执行sdk方法
   * @param command 方法名称
   * @param params 执行方法传入的参数
   * @returns Promise<any>
   */
  exec = (command: string, params: any) => {
    return new Promise((resolve, reject) => {
      this.ready(() => {
        this.checkApi(command).then(() => {
          // 处于二级路径环境下才处理
          if(command === "openLink" && params?.url && isSecondPath){
            params.url = getSecondPathUrl(params.url)
          }
          this.invoke(command, params).then(resolve).catch(reject);
        }).catch(err => {
          reject(err);
        });
      }, command).catch(err => {
        reject(err);
      });
    });
  }

  /**
   * 使用sdk打开链接
   * @param params params.url 为需要打开链接的地址 params.type 为打开类型
   * @returns Promise<any>
   */
  openLink = (params: any) => {
    return new Promise((resolve, reject) => {
      if (this.commandList['openLink'] && typeof (this.commandList['openLink']) == 'function') {
        params.success = resolve
        params.fail = reject
        this.commandList['openLink'](params)
      } else if (/Weapp/.test(ua.browser) && ua.device !== "PC" && ((params.type || "open") === 'open' || params?.openType)) {
        // 需要兼容在app内  目前优先处理 在emapp下的交互逻辑. 默认情况下走新开窗口. PC客户端无法兼容 不走默认逻辑
        // 并且兼容 只有默认打开方式走sdk服务  其它 href iframe route 走原始逻辑。 如果特殊指定openType的情况下 还是走sdk方法
        if (!params.openType) {
          params.openType = 2;
        }
        this.exec('openLink', params)
          .then((data) => {
            resolve(data);
          })
          .catch(() => {
            resolve(webOpen(params.url, params.type));
          });
      }  else {
        resolve(webOpen(params.url, params.type));
      }
    })
  }

  /**
   * 使用SDK下载功能
   * @param params params.url 为下载地址 params.type 为下载方式
   * @returns Promise<any>
   */
  download = (params: any) => {
    return new Promise((resolve, reject) => {
      let url = params.url;
      if (!url) {
        const isMobile = ua.device === 'Mobile';
        url = `/api${isMobile ? '/app' : ''}/file/remotedownload/${params.fileid}/${params.module || 'token'}/${true}`;
      }
      if (this.commandList['download'] && typeof (this.commandList['download']) == 'function') {
        params.url = url
        params.success = resolve
        params.fail = reject
        this.commandList['download'](params)
      } else {
        resolve(webOpen(url, params.type));
      }
    })
  }

  // filePreview = async (option: any) => {
  //   const { fileId, fileIds, isImage, onError, onSuccess } = option;
  //   const isMobile = ua.device === 'Mobile';
  //   let failError = () => {
  //     // pc/mb 提示方式不同
  //     if (isMobile) {
  //       window.weappUi?.MDialog.toast({
  //         type: 'fail',
  //         content: getLabel("59778", "预览失败"),
  //         delay: 2000
  //       })
  //     } else {
  //       window.weappUi?.Dialog.message({
  //         type: 'error',
  //         content: getLabel("59778", "预览失败")
  //       })
  //     }
  //   }
  
  //   // 预览分为
  //   // 1.图片预览（所有能够预览的图片都要走预览接口拿到图片地址）
  //   // 2.文件预览（文件预览只需要走一遍拿到文件的预览地址即可）
  //   if (isImage && fileIds) {// 1. 判断是否为图片预览
  //     let onSuccess = (images: any, fIndex: number) => {
  //       this.showImage({ data: images, photoIndex: fIndex });
  //     }
  //     imagePreview({
  //       fileIds,
  //       fileId,
  //       onError: onError || failError,
  //       onSuccess: onSuccess,
  //     });
  //   } else {
  //     try {
  //       let res = await previewRequest({ params: { fileId } });
  //       // 接口错误
  //       if (res.code !== 200) {
  //         onError ? onError() : failError();
  //         return;
  //       }
  //       const { loadUrl, previewLink, previewType, fileName } = res.data;
  //       if (isImage) {
  //         debugger;
  //         let images = [{
  //           id: fileId,
  //           src: loadUrl
  //         }]
  //         this.showImage({ data: images, photoIndex: 0 });
  //       } else if (getExtendName(fileName).toLowerCase() === 'mp4') {  // 视频预览
  //         // 非 pc 音频视频直接打开
  //         this.showVideo({ src: loadUrl })
  //       } else if (getExtendName(fileName).toLowerCase() === 'mp3') {  // 音频预览
  //         this.showAudio({ src: loadUrl })
  //       } else {  // 其他文件（excel、word 等）
  //         otherFilePreiver({
  //           previewLink: previewLink,
  //           loadUrl: loadUrl,
  //           previewType: previewType,
  //           onError: onError || failError
  //         });
  //       }
  //     } catch {
  //       onError ? onError() : failError();
  //     }
  //   }
  // }

  showImage = (params: any) => {
    return new Promise((resolve, reject) => {
      if (this.commandList['showImage'] && typeof (this.commandList['showImage']) == 'function') {
        params.success = resolve
        params.fail = reject
        this.commandList['showImage'](params)
      } else {
        resolve(showImage(params));
      }
    });
  }
  
  showVideo = (params: any) => {
    return new Promise((resolve, reject) => {
      if (this.commandList['showVideo'] && typeof (this.commandList['showVideo']) == 'function') {
        params.success = resolve
        params.fail = reject
        this.commandList['showVideo'](params)
      } else {
        resolve(showVideo(params));
      }
    });
  }

  showAudio = (params: any) => {
    return new Promise((resolve, reject) => {
      if (this.commandList['showAudio'] && typeof (this.commandList['showAudio']) == 'function') {
        params.success = resolve
        params.fail = reject
        this.commandList['showAudio'](params)
      } else {
        resolve(showAudio(params));
      }
    });
  }

  /**
   * 调用sdk修改页面title
   * @param params params.title 为需要设置的title
   * @returns Promise<any>
   */
  setTitle = (params: any) => {
    return new Promise((resolve, reject) => {
      if (this.commandList['setTitle'] && typeof (this.commandList['setTitle']) === 'function') {
        params.success = resolve
        params.fail = reject
        this.commandList['setTitle'](params)
      }
      //  else if (this.customSDK && this.customSDK.invoke) {
      //   params.success = resolve
      //   params.fail = reject
      //   this.customSDK.invoke('configNavigation', params)
      // }
      else {
        window.document.title = params?.title
        resolve('success');
      }
    })
  }
}

// 初始化sdk实例
const sdkInstance = new SDK();

// 三方设备判断条件
const isExtraDevice = /(MicroMessenger|wxwork|DingTalk|YunZhiJia|Welink|Lark|ZhengWuDing|miniProgram)/;

if (/Weapp/.test(ua.browser)) {
  sdkInstance.initSDK('@weapp/em-jssdk')
} else if (
  isExtraDevice.test(ua.browser) ||
  /^ebridge/.test(window.TEAMS?.currentUser?.loginChannel)
) {
  sdkInstance.initSDK('@weapp/ebjssdk');
  window.TEAMS?.ready?.('wxAuthAndConver', {
    success: function () {
      if (needConvertWechatData()) {
        convertWWOpenData();
      }
    }
  });
}

export const weappSDK = sdkInstance;

export default SDK;
